import QuotePipelineWidget from "@/components/widgets/QuotePipelineWidget";
import HoldsWidget from "@/components/widgets/HoldsWidget";
import DriverHOSAttentionWidget from "@/components/widgets/DriverHOSAttentionWidget";
import CoachLocationsMiniMap from "@/components/widgets/CoachLocationsMiniMap";

/**
 * Phase C Wave 2A — widget_key → custom component registry.
 *
 * The Dashboard shell consults this map FIRST. Any key not registered
 * falls back to the universal <WidgetCard> renderer. Adding a new
 * custom renderer = add one line here.
 */
export const WIDGET_RENDERER_REGISTRY = {
  quote_pipeline:          QuotePipelineWidget,
  holds:                   HoldsWidget,
  driver_hos_attention:    DriverHOSAttentionWidget,
  current_coach_locations: CoachLocationsMiniMap,
};

export const getCustomRenderer = (widgetKey) =>
  WIDGET_RENDERER_REGISTRY[widgetKey] || null;
